import { render, staticRenderFns } from "./OthIn.vue?vue&type=template&id=2a158e33"
import script from "./OthIn.vue?vue&type=script&lang=js"
export * from "./OthIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports